export enum EnabledService {
  RENT = 'Rent',
  DEBT = 'Debt',
  RENEWALS = 'Renewals',
  NONE = 'None',
}
